"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Sizes;

(function (Sizes) {
  Sizes["H1"] = "h1";
  Sizes["H2"] = "h2";
  Sizes["H3"] = "h3";
  Sizes["H4"] = "h4";
  Sizes["H5"] = "h5";
  Sizes["H6"] = "h6";
})(Sizes || (Sizes = {}));

exports.Sizes = Sizes;
var Variants;

(function (Variants) {
  Variants[Variants["STRONG"] = 0] = "STRONG";
  Variants[Variants["THIN"] = 1] = "THIN";
})(Variants || (Variants = {}));

exports.Variants = Variants;
var Colors;

(function (Colors) {
  Colors[Colors["DEFAULT"] = 0] = "DEFAULT";
  Colors[Colors["ACCENT"] = 1] = "ACCENT";
})(Colors || (Colors = {}));

exports.Colors = Colors;
var defaultProps = {
  color: Colors.DEFAULT,
  size: Sizes.H1,
  variant: Variants.STRONG
};

var Headline = function Headline(_a) {
  var id = _a.id,
      size = _a.size,
      variant = _a.variant,
      color = _a.color,
      className = _a.className,
      children = _a.children,
      asSpan = _a.asSpan,
      looksLike = _a.looksLike;
  var classNames = utils_1.DomUtils.cleanupClassNames([className, variant === Variants.THIN && CSSPrefix_1.lsgPre + "headline__thin", color === Colors.ACCENT && CSSPrefix_1.lsgPre + "headline__accent", CSSPrefix_1.lsgPre + "headline__" + size]);
  var headlineProps = {
    className: classNames,
    id: id,
    children: children
  };
  var Component = asSpan || looksLike ? "span" : size.toString();
  return React.createElement(Component, __assign({}, headlineProps)); // clarify how to properly type conditional rendered components
};

exports.Headline = Headline;
Headline.defaultProps = defaultProps;
Headline.Sizes = Sizes;
Headline.Variants = Variants;
Headline.Colors = Colors;

var H1 = function H1(props) {
  return React.createElement(Headline, __assign({
    size: Headline.Sizes.H1
  }, props));
};

exports.H1 = H1;

var H1Thin = function H1Thin(props) {
  return React.createElement(Headline, __assign({
    size: Headline.Sizes.H1,
    variant: Headline.Variants.THIN
  }, props));
};

exports.H1Thin = H1Thin;

var H2 = function H2(props) {
  return React.createElement(Headline, __assign({
    size: Headline.Sizes.H2
  }, props));
};

exports.H2 = H2;

var H2Thin = function H2Thin(props) {
  return React.createElement(Headline, __assign({
    size: Headline.Sizes.H2,
    variant: Headline.Variants.THIN
  }, props));
};

exports.H2Thin = H2Thin;

var H3 = function H3(props) {
  return React.createElement(Headline, __assign({
    size: Headline.Sizes.H3
  }, props));
};

exports.H3 = H3;

var H3Thin = function H3Thin(props) {
  return React.createElement(Headline, __assign({
    size: Headline.Sizes.H3,
    variant: Headline.Variants.THIN
  }, props));
};

exports.H3Thin = H3Thin;

var H4 = function H4(props) {
  return React.createElement(Headline, __assign({
    size: Headline.Sizes.H4
  }, props));
};

exports.H4 = H4;

var H4Thin = function H4Thin(props) {
  return React.createElement(Headline, __assign({
    size: Headline.Sizes.H4,
    variant: Headline.Variants.THIN
  }, props));
};

exports.H4Thin = H4Thin;

var H5 = function H5(props) {
  return React.createElement(Headline, __assign({
    size: Headline.Sizes.H5
  }, props));
};

exports.H5 = H5;

var H5Thin = function H5Thin(props) {
  return React.createElement(Headline, __assign({
    size: Headline.Sizes.H5,
    variant: Headline.Variants.THIN
  }, props));
};

exports.H5Thin = H5Thin;
Headline.displayName = "Headline";
H1.displayName = "H1";
H1Thin.displayName = "H1Thin";
H2.displayName = "H2";
H2Thin.displayName = "H2Thin";
H3.displayName = "H3";
H3Thin.displayName = "H3Thin";
H4.displayName = "H4";
H4Thin.displayName = "H4Thin";
H5.displayName = "H5";
H5Thin.displayName = "H5Thin";